import { createSlice, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {IDealerResultResponse} from "./interfaces";
import {IIndexable} from "../../../domain/interfaces";
import {default as cloneDeep} from "lodash/cloneDeep";
import {IFormControl} from "../../../ui/forms/interfaces";
import {createControl} from "../../../domain/validation/validation";
import {ICountry} from "../../../domain/addresses/interfaces";
import {getProductListData} from "../data-service";

const _productsList = getProductListData();
const _selectedCountryId=0;

/*
const CountryHasStates = (countryId:number) => {
    if (initialState && initialState.countries){
        let hasStates = false;
        if(countryId && countryId > 0){
            let country = initialState.countries.find(country => country.countryID.toString() === countryId.toString());
            if(country && country.states && country.states.length > 0){
                hasStates = true;
            }
        }
        return hasStates;
    }
}*/

export interface StateInterface extends IIndexable{
    DealerResultResponse: IDealerResultResponse,
    selectedCountryId:number,
    countries: ICountry[],
    countryIdControl: IFormControl,
    stateIdControl: IFormControl,
    categoryIdControl:IFormControl,
    ProductList:any[],
    isFirstLoad:boolean,
}
// initial state
    const initialState: StateInterface = {
        isFirstLoad:true,
    DealerResultResponse : {} as IDealerResultResponse,
    ProductList:_productsList && _productsList.products,
    selectedCountryId:_selectedCountryId,
    countries:[],

    countryIdControl:createControl(
        'countryId',
         0,{
            required: true
        }),
    stateIdControl:createControl(
        'stateId',
         0,{
            // required: CountryHasStates(_selectedCountryId)
        }),
        categoryIdControl:createControl(
            'productId',
            'eMotion',{
                required:true
            }
        )
}
// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
        setControl(state, action) {

            return {
                ...state,
                [action.payload.controlName]: cloneDeep(action.payload.control),
            }
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;


